import type {
  BulkAddEventGuestsRequest,
  BulkAddEventGuestsResponse,
  CreateEventGuestRequest,
  EventGuestResponse,
  ListEventGuestsResponse,
} from '@jq4race/shared';

import { request } from './client.js';

// ── Event guests (S2: pre-load guest list + bulk paste) ─────────────────────

export async function listEventGuests(eventId: string): Promise<ListEventGuestsResponse> {
  return request<ListEventGuestsResponse>(`/admin/events/${encodeURIComponent(eventId)}/guests`, {
    method: 'GET',
  });
}

export async function addEventGuest(
  eventId: string,
  input: CreateEventGuestRequest,
): Promise<EventGuestResponse> {
  return request<EventGuestResponse>(`/admin/events/${encodeURIComponent(eventId)}/guests`, {
    method: 'POST',
    body: input,
  });
}

export async function bulkAddEventGuests(
  eventId: string,
  input: BulkAddEventGuestsRequest,
): Promise<BulkAddEventGuestsResponse> {
  return request<BulkAddEventGuestsResponse>(
    `/admin/events/${encodeURIComponent(eventId)}/guests/bulk`,
    { method: 'POST', body: input },
  );
}
